import { useNavigate } from 'react-router-dom';
import { v4 as uuid4 } from 'uuid';
import { PATH } from '../../../constants';
import { recommendedArtists } from '../../../test.data';
import Button from '../../button/v2/button';
import AsideSection from '../../containers/aside/aside.section';
import Avatar from '../../images/avatar';
import { HStack, VStack } from '../../layouts/stack.layout';
import { DISCOVER_TAB_OPTIONS } from '../../navigation/tabs/tab-options';

export default function RecommendedArtists() {
  const path = `/${PATH.DISCOVER}?tab=${DISCOVER_TAB_OPTIONS.RECOMMENDED}`;
  const navigate = useNavigate();
  return (
    <AsideSection path={path} title="Recommended Artists">
      {recommendedArtists.slice(0, 3).map((artist) => (
        <HStack
          onClick={() => navigate(`/${artist.username}`)}
          gap="sm"
          key={uuid4()}
          extensions="cursor-pointer w-full items-center py-3 px-5 hover:bg-white/[5%] ease-in transition-colors px-[50px]"
          justify="between"
        >
          <HStack gap="sm" extensions="items-center w-full">
            <Avatar size="sm" url={artist.avatarUrl} alt={artist.username} />
            <VStack extensions="w-full">
              <div className="font-text w-[calc(100%-50px)] text-sm font-medium text-primary whitespace-nowrap text-ellipsis overflow-hidden">
                {artist.displayName}
              </div>
              <div className="font-text text-xs text-info">
                @{artist.username}
              </div>
            </VStack>
          </HStack>
          <Button variant="outline" size="sm">
            Track
          </Button>
        </HStack>
      ))}
    </AsideSection>
  );
}
